import { render } from "./3DContrib.vue?vue&type=template&id=aa9d9efa&scoped=true"
import script from "./3DContrib.vue?vue&type=script&lang=js"
export * from "./3DContrib.vue?vue&type=script&lang=js"

import "./3DContrib.vue?vue&type=style&index=0&id=aa9d9efa&lang=scss&scoped=true"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9d9efa"]])

export default __exports__